import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCrop from '../_reducers/crop';

export const selectCropState = createFeatureSelector<fromCrop.CropState>('crops');

export const selectAllCrops = createSelector(selectCropState, fromCrop.selectAll);

export const selectCropEntities = createSelector(selectCropState, fromCrop.selectEntities);

export const selectCropById = (id: number) =>
  createSelector(selectCropEntities, (entities) => entities[id]);

export const selectCropTotal = createSelector(selectCropState, fromCrop.selectTotal);
